import { Component } from "react";
import { CategoryNavigator } from "./CategoryNavigator";
import { ProductsList } from "./ProductsLIst";
import image from '../images/image.jpeg';
export class Shop extends Component{

    
    render(){

        const footer = [
            {header:'CUSTOMER SERVICES', a:'Help & Contact',b:'Returns & Refuns',c:'Online Stores'},
            {header:'SOCIAL MEDIA', a:'Twitter',b:'Instagram',c:'Facebook'},
            {header:'PROFILE', a:'My Account',b:'Checkout',c:'Help & Support'}
        ];

        return(<div className="px-10">
            <div className="h-[400px] relative p-10">
                <img src={image} alt="/" className="w-full h-full object-cover object-center"/>
                <div className="w-64 absolute bottom-20 left-20">
                <h1 className="tracking-wide text-slate-900 text-2xl">THINK DIFFERENT</h1>
                <p className="text-[10px] tracking-wide">Depot a unique & captureing them designed specially for all types of shops and online stores</p>
                </div>    
            </div>
            <div className="px-10 py-2 flex gap-2">
                <CategoryNavigator categories={this.props.user.categories} baseUrl="/shop/products"/>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 py-2 gap-10 justify-items-center items-stretch">
                <ProductsList {...this.props} product={this.props.pro} baseUrl="/shop/products"/>
            </div>
            
            <div className="p-10 flex justify-around">
                {footer.map((r,i)=>
                <div key={i}>
                    <h5 className="text-sm font-semibold tracking-wide text-slate-600">{r.header}</h5>
                    <p className="text-sm text-slate-500">{r.a}</p>
                    <p className="text-sm text-slate-500">{r.b}</p>
                    <p className="text-sm text-slate-500">{r.c}</p>
                </div>
                )}
            </div>
        </div>)
    }
}